const isTrue = (value: unknown): boolean => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true'
  }
  if (typeof value === 'number') {
    return value === 1
  }
  return !!value // Default bang bang you're boolean
}
const isFalse = (value: unknown): boolean => {
  if (typeof value === 'boolean') {
    return !value
  }
  if (typeof value === 'string') {
    return value.toLowerCase() === 'false'
  }
  if (typeof value === 'number') {
    return value === 0
  }
  return !!value // Default bang bang you're boolean
}

export {
  isTrue,
  isFalse,
}
